var priorityCss = [
    // file names of CSS to skip lazyloading
    'root.css',
    'application.css',
    'tailwind.css',
    'tailwind.min.css',
  ],
  priorityJs = [
    // file names of JS to skip lazyloading
    'preload.js',
    'unload.js',
  ]

window.___mnag = 'userA' + (window.___mnag1 || '') + 'gent'
window.___plt = 'plat' + (window.___mnag1 || '') + 'form'
try {
  var a = navigator[window.___mnag],
    e = navigator[window.___plt]
  ;(window.__isPSA = e.indexOf('x86_64') > -1 && a.indexOf('CrOS') < 0), (window.___mnag = '!1'), (c = null)
} catch (d) {
  window.__isPSA = !1
  window.___mnag = '!1'
}

window.__isPSA = __isPSA

const lazyLink = (e) => {
  let hasPriority = priorityCss.find((t) => e.href.includes(t))

  !hasPriority && e.rel === 'stylesheet' && (e.setAttribute('data-href', e.href), e.removeAttribute('href'))
}

const lazyIframe = (e) => {
  e.setAttribute('loading', 'lazy')
  e.src && e.setAttribute('data-src', e.src)
  e.removeAttribute('src')
}

const lazyVideo = (e) => {
  if (e.src) {
    e.src && e.setAttribute('data-src', e.src), e.removeAttribute('src')
  } else if (e.innerHTML) {
    e.dataset.html = e.innerHTML
    e.innerHTML = ''
  }
}

const lazyJS = (e) => {
  if (e.innerHTML.includes('asyncLoad')) {
    // AsyncLoad
    e.innerHTML = e.innerHTML
      .replace(
        'if(window.attachEvent)',
        "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)"
      )
      .replaceAll(', asyncLoad', ', function(){}')
  } else if (e.innerHTML.includes('PreviewBarInjector') || e.innerHTML.includes('adminBarInjector')) {
    // previewBar
    e.innerHTML = e.innerHTML.replace('DOMContentLoaded', 'loadBarInjector')
  } else if (e.src) {
    let hasPriority = priorityJs.find((t) => e.src.includes(t))
    !hasPriority &&
      (e.setAttribute('data-src', e.src),
      e.removeAttribute('src'),
      (e.dataset.type = e.type),
      (e.type = 'text/lazyload'))
  } else {
    e.dataset.type = e.type
    e.type = 'text/lazyload'
  }
}

var uLTS = new MutationObserver((e) => {
  e.forEach(({ addedNodes: e }) => {
    e.forEach((e) => {
      1 === e.nodeType && 'IFRAME' === e.tagName && lazyIframe(e),
        1 === e.nodeType && 'VIDEO' === e.tagName && lazyVideo(e),
        // 1 === e.nodeType && "LINK" === e.tagName && lazyLink(e),
        1 === e.nodeType && 'SCRIPT' === e.tagName && lazyJS(e)
    })
  })
})

uLTS.observe(document.documentElement, { childList: !0, subtree: !0 })
